import React from 'react';
import { useParams } from 'react-router';
import CompanyDetailEdit from '../../../components/CompanyDetail/CompanyDetail';

const CompanyDetailsPage = ({ scrollTop }) => {
  const { id: companyId } = useParams();
  return (
    <div>
      <CompanyDetailEdit companyId={companyId} scrollTop={scrollTop} />
    </div>
  );
};

export default CompanyDetailsPage;
